/* eslint-disable no-unused-vars */
import { initWorker } from 'worker-lib';
import type { ModuleType } from './webp.js';

let webpModule: ModuleType;
const getModule = async () => {
  const webp = await import('./webp.js').then((m) => m.default);
  if (!webpModule) {
    let module = await webp().catch(() => null);
    if (!module) {
      module = await webp();
      if (!module) throw new Error('module failed to load');
    }
    webpModule = module;
  }
  return webpModule;
};
const encode = async (
  data: BufferSource,
  width: number,
  height: number,
  quality: number
): Promise<Uint8Array | null> => {
  return (await getModule()).encode(data, width, height, quality);
};

// Initialization process to make it usable in Worker.
const map = initWorker({ encode });
// Export only the type
export type WorkerEncoder = typeof map;
